import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';
import MicroModal from 'micromodal';
import { setWithExpiry, getWithExpiry } from '../shared/utils.js';

const EXPIRATION_DAYS = 3;
const EXPIRATION_MS = EXPIRATION_DAYS * 24 * 60 * 60 * 1000;
const STORAGE_KEY = 'hide-modal-multisub';

injector.injectClass(class extends Script {
    onLoad() {
        if ($('#modal_multisub').length) {
            const hide = getWithExpiry(STORAGE_KEY);
            if (hide) return;

            $('#multisub_hide').on('click', () => {
                setWithExpiry(STORAGE_KEY, true, EXPIRATION_MS);
                MicroModal.close('modal_multisub');
            });

            MicroModal.show('modal_multisub');
        }
    }
});
